import angular from 'angular'

const tableRelatedModule = angular.module('app.tableRelatedModule', [])

export default tableRelatedModule.name

tableRelatedModule.directive('tableDropdown', [
    'operationService',
    (operationService) => ({
        restrict: 'AE',
        replace: true,
        template: `
        <div style="" class="btn-group dropdown-group">
            <button type="button" class="btn btn-default btn-xs">
                <span class="caret"></span>
            </button>
            <ul class="dropdown-menu" role="menu" aria-labelledby="simple">
                <li ng-repeat="item in config track by $index">
                    <a class="text-center" ng-if="showItem(item)&& item.type!='file'" ng-click="item.handler(tableCell)">{{item.label}}</a>
                    <a ng-if="showItem(item) && item.type=='file'" type="file" ngf-max-height="5000" ngf-multiple="{{item.multiple}}" ngf-max-size="{{item.maxSize}}" class="text-center" ngf-select="item.handler(tableCell,$files, $invalidFiles)">{{item.label}}</a>
                </li>
            </ul>
        </div>
    `,
        scope: {
            tableCell: '=',
            config: '<',
            alwaysShow: '<', //整个组件一直显示
            nothingHide: '<', //当没有下拉选项时是否隐藏整个组件
        },
        link(scope, element) {
            const hasPermit = operationService.hasPermit.bind(operationService)

            // 至少有一个下拉菜单显示
            function atLeastOneChildShow(config, tableCell) {
                return config.some((item) => {
                    if (!item.showWhile) {
                        return true
                    }
                    if (item.showWhile(tableCell, hasPermit)) {
                        return true
                    }
                    return false
                })
            }
            let hasMenu = atLeastOneChildShow(scope.config, scope.tableCell)
            const button = element.find('button')
            const dropdown = element.find('ul')
            if (hasMenu) {
                button.show()
            } else {
                button.hide()
            }
            element
                .parent()
                .on('mouseenter', () => {
                    if (hasMenu) {
                        dropdown.show()
                    }
                })
                .on('mouseleave', () => {
                    dropdown.hide()
                })
            scope.showItem = function showItem(item) {
                if (!item.showWhile) {
                    return true
                }
                return item.showWhile(scope.tableCell, hasPermit)
            }
        },
    }),
])

tableRelatedModule.directive('tableCheckbox', () => ({
    restrict: 'AE',
    replace: true,
    template: `
        <label for="{{'checkbox_' + refRowData[key]}}" class="et-cb-wrapper">
            <input type="checkbox" ng-change="onChange()" ng-disabled="disabled"  ng-model="refRowData.selected" id="{{'checkbox_' + refRowData[key]}}">
            <label for="{{'checkbox_' + refRowData[key]}}" class="et-cb-label"></label>
        </label>
    `,
    scope: {
        refRowData: '=', // 每一行的数据
        key: '@', // 行数据ID
        selectedType: '@', // 默认值‘id’：只返回ID数组，取值object返回整个对象
        refSelected: '=',
        checkAll: '@',
        disabled: '@',
    },
    link(scope) {
        // scope.refRowData.selected = false
        scope.$watch('refRowData.selected', () => {
            const { key } = scope
            let existIndex
            if (!scope.refRowData.selected) {
                scope.refSelected &&
                    scope.refSelected.every((rowdata, index) => {
                        if (scope.selectedType === 'object' && rowdata[key] === scope.refRowData[key]) {
                            existIndex = index
                            return false
                        }
                        if (rowdata === scope.refRowData[key]) {
                            existIndex = index
                            return false
                        }
                        return true
                    })
                if (existIndex || existIndex === 0) {
                    scope.refSelected.splice(existIndex, 1)
                }
            } else if (scope.selectedType === 'object') {
                if (!scope.refSelected.some((selected) => selected === scope.refRowData)) {
                    scope.refSelected.push(scope.refRowData)
                }
            } else if (!scope.refSelected.some((selected) => selected === scope.refRowData[key])) {
                scope.refSelected.push(scope.refRowData[key])
            }
        })
    },
}))

tableRelatedModule.directive('tableCheckall', () => ({
    restrict: 'E',
    replace: true,
    template: `
        <label for="table-check-all-{{namespace}}-{{key}}" class="et-cb-wrapper">
            <input type="checkbox" id="table-check-all-{{namespace}}-{{key}}" ng-disabled="disabled" ng-model="selected" ng-change="onChange()">
            <label for="table-check-all-{{namespace}}-{{key}}" class="et-cb-label"></label>
        </label>
    `,
    scope: {
        refList: '=',
        refSelected: '=',
        selectedType: '@',
        namespace: '@',
        key: '@',
        disabled: '@',
    },
    link(scope) {
        scope.selected = false
        scope.onChange = function onChange() {
            scope.refSelected.splice(0, scope.refSelected.length)
            scope.refList.forEach((rowData) => {
                rowData.selected = scope.selected
                if (scope.selected) {
                    scope.refSelected.push(scope.selectedType === 'object' ? rowData : rowData[scope.key])
                }
            })
        }
        scope.$watch('refSelected.length', (newLength) => {
            scope.selected = newLength && newLength === scope.refList.length && newLength !== 0
        })
        scope.$watch('refList.length', (newLength) => {
            scope.selected = newLength && newLength === scope.refSelected.length && newLength !== 0
        })
    },
}))



// WEBPACK FOOTER //
// ./src/components/tableRelated/index.js